import { render } from "./ReportBanner.vue?vue&type=template&id=2884ff10&scoped=true"
import script from "./ReportBanner.vue?vue&type=script&lang=js"
export * from "./ReportBanner.vue?vue&type=script&lang=js"

import "./ReportBanner.vue?vue&type=style&index=0&id=2884ff10&lang=scss&scoped=true"
import "./ReportBanner.vue?vue&type=style&index=1&id=2884ff10&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2884ff10"]])

export default __exports__